import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

// franklycatering #1405 — read-only conversation thread for a contact, backed
// by the GHL message mirror (`contact_messages`). The select list below is
// deliberate: it omits the raw-email-HTML column, which must never reach the
// client (see the table's COMMENT in the creating migration).
const CONTACT_MESSAGES_SELECT = "id, direction, channel, body, subject, sent_at, status, attachments";

// Keeps the thread readable and the payload bounded; conversations with more
// history than this just show the most recent 200 messages.
const CONTACT_MESSAGES_LIMIT = 200;

export interface ContactMessageAttachment {
  type: string;
  url: string;
}

export interface ContactMessage {
  id: string;
  direction: string | null;
  channel: string;
  body: string | null;
  subject: string | null;
  sent_at: string;
  status: string | null;
  attachments: ContactMessageAttachment[];
}

export function useContactMessages(contactId: string | null | undefined) {
  return useQuery({
    queryKey: ["contact_messages", contactId],
    enabled: !!contactId,
    staleTime: 30_000,
    queryFn: async (): Promise<ContactMessage[]> => {
      const { data, error } = await supabase
        .from("contact_messages")
        .select(CONTACT_MESSAGES_SELECT)
        .eq("contact_id", contactId!)
        .order("sent_at", { ascending: false })
        .limit(CONTACT_MESSAGES_LIMIT);
      if (error) throw error;
      return (data ?? []) as unknown as ContactMessage[];
    },
  });
}
